import type { ThreadSchema } from "@/stores/threads-store";

export interface ThreadSection {
    key: "this" | "other" | "all";
    label: string | null;
    threads: ThreadSchema[];
}

/**
 * Split the thread list into "On this page" / "On other pages" sections, given
 * the set of thread identities that relate to the current page's entity.
 *
 * Falls back to a single flat, unlabelled section when nothing relates to the
 * current page (or there is no current entity), so the list looks unchanged on
 * pages without page-specific threads. Empty sections are dropped.
 */
export const groupThreadsByPage = (
    threads: ThreadSchema[],
    onThisPageIds: Set<string>
): ThreadSection[] => {
    const onPage: ThreadSchema[] = [];
    const other: ThreadSchema[] = [];
    for (const thread of threads) {
        if (onThisPageIds.has(thread.identity)) onPage.push(thread);
        else other.push(thread);
    }

    if (onPage.length === 0) {
        return [{ key: "all", label: null, threads: other }];
    }

    return (
        [
            { key: "this", label: "On this page", threads: onPage },
            { key: "other", label: "On other pages", threads: other },
        ] as ThreadSection[]
    ).filter((section) => section.threads.length > 0);
};
